import { HOLIDAYS as NATIONAL_HOLIDAYS } from "./holidays.js";
const wd = (d) => new Date(d + "T00:00:00Z").getUTCDay();

const today = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Manila" }).format(
    new Date(),
  );

const fmtD = (d) =>
  new Date(d + "T00:00:00").toLocaleDateString("en-PH", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

function addDays(d, n) {
  const x = new Date(d + "T00:00:00Z");
  x.setUTCDate(x.getUTCDate() + n);
  return x.toISOString().slice(0, 10);
}

const HOLIDAYS = NATIONAL_HOLIDAYS.map((h) => h.date);

function roll(d) {
  while (
    [0, 6].includes(new Date(d + "T00:00:00Z").getUTCDay()) ||
    HOLIDAYS.includes(d)
  )
    d = addDays(d, 1);
  return d;
}

const daysTo = (d) =>
  Math.round(
    (new Date(d + "T00:00:00Z") - new Date(today() + "T00:00:00Z")) / 864e5,
  );

const quarterOf = (d) => `Q${Math.ceil(+d.slice(5, 7) / 3)} ${d.slice(0, 4)}`;

const qEnd = (d) => {
  const m = Math.ceil(+d.slice(5, 7) / 3) * 3;
  return `${d.slice(0, 4)}-${String(m).padStart(2, "0")}-${m === 6 || m === 9 ? "30" : "31"}`;
};

const shortD = (d) => fmtD(d).replace(/, \d{4}$/, "");

const when = (t) =>
  !t
    ? "Not yet"
    : new Date(t).toLocaleString("en-PH", {
        timeZone: "Asia/Manila",
        dateStyle: "medium",
        timeStyle: "short",
      });

export {
  wd,
  today,
  fmtD,
  addDays,
  HOLIDAYS,
  roll,
  daysTo,
  quarterOf,
  qEnd,
  shortD,
  when,
};
